(function($){
	$(document).ready(function() {
	
		// console.log('cur-header.js loaded!');
	
		$('.cur-header .hamburger .hamburger-container').on('click', function(event) {
			if (!$('.main-menu').hasClass('locked')) {
				if ($('.main-menu').hasClass('open')) {
					closeMenu();
				} else {
					$('.main-menu').addClass('locked');
					// $('.cur-header .hamburger img').attr("src", imageSrc);
					$('.cur-header').addClass('scrolled');
					$('.cur-header').addClass('menu-open');
					$('.main-menu').slideDown(250, function() {
						$('.main-menu').removeClass('locked');
						$('.main-menu').addClass('open');
						$('body').addClass('no-scroll');
					});
				}
			}
		});

		let resetmenu = null;
		let opentimer = null;
		let closetimer = null;
		const isdesktop = window.matchMedia('(min-width: 992px)');
		// console.log(isdesktop);

		// submenu rollover (desktop)
		$('.main-menu > ul > li').on('mouseenter', function(event) {

			if (!isdesktop.matches) return;
			if (closetimer) { 
				clearTimeout(closetimer); 
				closetimer = null;
			}
			const $li = $(this);

			if ($li.find('.drop').length === 0) {
				$('.cur-header .main-menu li.has-submenu.open')
					.removeClass('open')
					.children('.drop').stop(true, true).slideUp(200);
				$('.main-menu').attr('data-open', '');
				return; // nothing else to do for non-dropdown items
			}

			// console.log('rolled over!');
			opentimer = setTimeout(function(){

				// console.log('opentimer fired');

				if (!$('.cur-header .main-menu').hasClass('locked') && $li.find('.drop').length !== 0) {
					// console.log('passed the conditionals!');
					$('.cur-header .main-menu').addClass('locked');
					$('.cur-header .main-menu li.has-submenu.open').find('.drop').stop(true, true).slideUp(200, function(event) {
						// console.log($(this));
						$(this).removeClass('open');
					});
					if ($li.find('.drop').length !== 0) {
						$li.addClass('open').siblings().removeClass('open');
						let myID = $li.data('id');
						$('.main-menu').attr('data-open', myID);
						$li.children('.drop').stop(true, true).slideDown(300, function(event) {
							setTimeout(function() {
								$('.cur-header .main-menu').removeClass('locked');
							}, 160);
						});
					}
				}

			}, 120);
		});
		
		$('.main-menu > ul > li').on('mouseleave', function(event) {

			if (!isdesktop.matches) return;
			if (opentimer) { 
				clearTimeout(opentimer); 
				opentimer = null;
			}
			const $li = $(this);

			closetimer = setTimeout(function(){
				if (!$('.cur-header .main-menu').hasClass('locked') && $li.find('.drop').length) {
					$('.cur-header .main-menu li.has-submenu').children('.drop').stop(true, true).slideUp(200, function(event) {
						$('.main-menu').attr('data-open', '');
						$li.removeClass('open');
						$('.cur-header .main-menu').removeClass('locked');
					});
				}
			}, 220);
		});
	
		// submenu click (mobile) — only trap clicks for NON link-through parents
		$('.main-menu > ul > li.has-submenu:not(.link-through) > a').click(function(event) {
			event.preventDefault();
			if ($(this).parent().css('display') == 'block') { // i.e. mobile
				if (!$(this).parent().hasClass('open')) {
					$('.main-menu > ul > li.open').removeClass('open').children('.drop').stop(true, true).slideUp(300).removeClass('open');
					$(this).parent().addClass('open');
					$(this).siblings('.drop').addClass('open').stop(true, true).slideDown(300);
				} else {
					$(this).parent().removeClass('open');
					$(this).siblings('.drop').addClass('open').stop(true, true).slideUp(300);
				}
			}
		});

		// allow link-through parents to navigate on mobile; also collapse menu for polish
		$('.main-menu > ul > li.link-through > a').on('click', function() {
			if ($(this).parent().css('display') == 'block') { // mobile
				if (!$(this).parent().hasClass('open')) {
					event.preventDefault();
					$(this).parent().addClass('open');
					$(this).closest('ul').children('li.has-submenu').not('.open').stop(true, true).slideUp(300);
					$(this).siblings('.drop').addClass('open').slideDown(300);
					myID = $(this).parent().data('id');
					$('.main-menu').attr('data-open', myID);
					if ($('.main-menu .reset').is(":hidden")) {
						$('.main-menu .reset').fadeIn(300);
					}
				} else {
					closeMenu();
				}
			}
		});
	
		window.closeMenu = function() {
			$('.main-menu').addClass('locked');
			$('.main-menu').slideUp(250, function() {
				// $('.cur-header .hamburger img').attr("src", imageSrc);
				$('.main-menu').removeClass('locked');
				$('.main-menu').removeClass('open');
				$('body').removeClass('no-scroll');
				$('.cur-header').removeClass('menu-open');
				$('.main-menu').attr('data-open', '');
				$('.main-menu > ul > li.has-submenu').not('.desktop-only').stop(true, true).slideDown(300).removeClass('open');
				$('.main-menu > ul > li.has-submenu .drop').stop(true, true).slideUp(300).removeClass('open');
				$('.main-menu .reset').fadeOut(300);
				if ($(document).scrollTop() < 20) {
					$('.cur-header').removeClass('scrolled');
				}
			});
		}
	
		$(document).on("click", function(event) {
			if (window.innerWidth >= 768) { return; }
			const $target = $(event.target);
			if ($target.closest('.hamburger').length) return;
			if ($target.closest('nav.main-menu').length) return;
			// if ($('.cur-header .main-menu > ul > li').css('display') != 'block') return;

			$('.cur-header .main-menu li.has-submenu .drop').stop(true,true).slideUp(200);
			$('.cur-header .main-menu li.has-submenu').removeClass('open');
			$('.main-menu').attr('data-open','').removeClass('locked');

			$('.cur-header .main-menu').stop(true, true).slideUp(300, function(event) {
				$(this).removeClass('open');
			});          
		});

	});
})(jQuery);